module.exports = __webpack_public_path__ + "static/tab_header_icon_black_117x117-1afcc779242eb94e996127d288a64808.png";